import { useMemo } from "react";
import useNewDataFetcher from "../../../../Hooks/newUseDataFetcher";
import GraphTable from "../../../../Components/GraphTable";
import SubheaderTimePeriod from "../../../../Components/SubheaderTimePeriod";
import { formatNumber } from "../../../../Utilities/formatting";

function ByValue() {
  const dataURL = "/api/v1/result/placements/by-value"
  const { data, dateRange, filterTypes, filters, isReady } = useNewDataFetcher({
    endPoint: dataURL,
  });

  const average = useMemo(() => {
    if (!data) return 0;
    let total = 0;
    let placements = 0;
    data.data.forEach((row) => {
      total += row.totalValue;
      placements += row.countOfPlacements;
    });
    return Math.round(total / placements);
  }, [data]);

  return (
    <GraphTable data={data} dateRange={dateRange} filterTypes={filterTypes} filters={filters} isReady={isReady} interval={dateRange.interval} dataURL={dataURL}>
      <h1 className="page-heading">What is our average placement value?</h1>
      <h2 className="page-subheading">
        $<span className="page-data">{formatNumber(average)}</span> average value for placements created <SubheaderTimePeriod data={dateRange} />
      </h2>
    </GraphTable>
  );
}

export default ByValue;
